<template>
  <template v-if="loggedIn">
    <headnav />
    <div class="content-split" :class="{'menu-open': stores.page.menuOpen, transition: isTransitioning}">
      <sidenav />
      <div class="content-container">
        <router-view />
      </div>
    </div>
  </template>
  <router-view v-else />
  <toast />
</template>

<script>
import api from '@/Util/api'
export default {
  data: ()=>({
    isTransitioning: false,
  }),
  computed: {
    loggedIn() {
      return this.$route.name!="login";
    },
  },
  watch: {
    "stores.page.menuOpen"() {
      this.stores.page.saveMenuOpen();
      this.isTransitioning=true;
      setTimeout(()=>this.isTransitioning=false, 300);
    },
    "stores.auth.currentUser"() {
      if (!this.stores.auth.currentUser)
        this.$router.replace({name: "login"});
    },
    "stores.auth.loginValidated"() {
      if (!this.stores.auth.currentUser)
        this.$router.replace({name: "login"});
    },
  },
  created() {
    window.appRoot=this;
    api.stores=this.stores;
    this.stores.auth.loadStoredToken();
    this.stores.page.loadMenuOpen();
  },
}
</script>

